// Prevent form submit on enter key except TEXTAREA elements
// Static import, included with site.js
$(document).on("keypress", "input:not(.no-prevent)", function (e) {
  if (e.which == 13 && e.target.tagName != "TEXTAREA") {
      return false;
  }
});